export default __webpack_public_path__ + "static/media/diabetes.20836db8.jpg";